// extracted by mini-css-extract-plugin
export var resizer = "_fi-0";